import React from 'react';
import { twMerge } from 'tailwind-merge';
import { PreloadImage } from '~/components/preload-image';

interface SearchFiltersArrowButtonProps {
  direction: 'left' | 'right';
  onClick: () => void;
  show: boolean;
  styles: any;
  searchScreenId: string;
}

/**
 * Arrow button for scrolling search filter tabs horizontally.
 * Uses search_filters_arrows_* styles from the search_v2 manifest.
 */
export function SearchFiltersArrowButton({
  direction,
  onClick,
  show,
  styles,
  searchScreenId,
}: SearchFiltersArrowButtonProps): JSX.Element {
  const isLeft = direction === 'left';
  const arrowId = `search-filter-arrow-${direction}-${searchScreenId}`;

  const leftArrowAsset = styles?.search_filters_arrows_left_arrow_asset;
  const rightArrowAsset = styles?.search_filters_arrows_right_arrow_asset;

  return (
    <button
      type="button"
      onClick={onClick}
      className={twMerge(
        'group search-filters-scroll-arrow pointer-events-auto absolute top-1/2 z-10 -translate-y-1/2',
        isLeft
          ? 'search-filters-scroll-arrow-left'
          : 'search-filters-scroll-arrow-right',
        !show && 'pointer-events-none opacity-0'
      )}
      aria-label={`Scroll search filters ${direction}`}
      aria-disabled={!show}
      data-testid={arrowId}
    >
      {isLeft && leftArrowAsset && (
        <>
          <PreloadImage tailwindImageClass="search-filters-left-arrow-asset" />
          <PreloadImage tailwindImageClass="search-filters-left-arrow-asset-hover" />
        </>
      )}
      {!isLeft && rightArrowAsset && (
        <>
          <PreloadImage tailwindImageClass="search-filters-right-arrow-asset" />
          <PreloadImage tailwindImageClass="search-filters-right-arrow-asset-hover" />
        </>
      )}
      {isLeft && leftArrowAsset ? (
        <div className="search-filters-left-arrow-asset bg-contain bg-center bg-no-repeat group-hover:search-filters-left-arrow-asset-hover" />
      ) : !isLeft && rightArrowAsset ? (
        <div className="search-filters-right-arrow-asset bg-contain bg-center bg-no-repeat group-hover:search-filters-right-arrow-asset-hover" />
      ) : (
        <svg
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          className="h-6 w-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={isLeft ? 'M15 19l-7-7 7-7' : 'M9 5l7 7-7 7'}
          />
        </svg>
      )}
    </button>
  );
}
